/* jshint esnext: true */

class SceneMenu extends Phaser.Scene {

	constructor() {

		super( { key: 'SceneMenu' } );

		this.maze = null;
		this.speed = 0.5;
		this.vx = this.speed;
		this.vy = this.speed;

	}


	/**
	 *
	 */
	create() {

		const game_size = get_game_size();
		const width = Math.ceil( game_size.width / settings.tileWidth ) * 2;
		const height = Math.ceil( game_size.height / settings.tileWidth ) * 2;

		const display_width = width * settings.tileWidth;
		const display_height = height * settings.tileHeight;

		mazes.setup( width, height );
		this.maze = mazes.create( this );

	}


	/**
	 *
	 */
	update() {

		var camera = this.cameras.main;

		camera.scrollX += this.vx;
		camera.scrollY += this.vy;

		let bounds_x = game.scale.width;
		let bounds_y = game.scale.height;

		if ( camera.scrollX < 0 ) {
			camera.scrollX = 0;
			this.vx = this.speed;
		}

		if ( camera.scrollX > bounds_x ) {
			camera.scrollX = bounds_x;
			this.vx = -this.speed;
		}

		if ( camera.scrollY < 0 ) {
			camera.scrollY = 0;
			this.vy = this.speed;
		}

		if ( camera.scrollY > bounds_y ) {
			camera.scrollY = bounds_y;
			this.vy = -this.speed;
		}

	}

}